exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-a9064afe]{width:1.12rem;height:.28rem;display:flex;align-items:center;color:#1f1f1f;font-size:.14rem;border-radius:.04rem;line-height:.28rem}.status img[data-v-a9064afe]{width:.24rem;margin-right:.06rem;margin-left:.1rem}.status.ing[data-v-a9064afe]{background:rgba(0,199,131,.2);color:#00c783}.status.passed[data-v-a9064afe]{background:rgba(49,114,253,.2);color:#3172fd}.status.failed[data-v-a9064afe]{background:rgba(146,157,173,.2);color:#929dad}", ""]);

// exports
